import { toast } from 'react-toastify';
import { backendURL } from 'redux/reducers/settings';
import { useAddEndImageMutation, useAddStartImageMutation } from 'redux/reducers/training';

interface EndandStartImageProps {
  routineId: string|number;
  routineInfo: any;
}

const EndandStartImage = ({ routineId, routineInfo }: EndandStartImageProps) => {
  const [addStartImage] = useAddStartImageMutation();
  const [addEndImage] = useAddEndImageMutation();
  const handleUploadStartImage = (file: File | null) => {
    let executeFunc = addStartImage;
    const payload = { id: routineId, start_training_image: file };
    executeFunc(payload)
      .unwrap()
      .then(() => {
        toast.success('Added Successfully');
      })
      .catch(() => {
        toast.error('Error');
      });
  };

  const handleUploadEndImage = (file: File | null) => {
    const payload = { id: routineId, end_training_image: file };
    let executeFunc = addEndImage;

    executeFunc(payload)
      .unwrap()
      .then(() => {
        toast.success('Added Successfully');
      })
      .catch(() => {
        toast.error('Error');
      });
  };

  console.log('fsdfdsf',routineInfo);
  

  return (
    <div className="row ">
      <div className="col-6">
        Start Image
        <div className="">
          <input
            id="profile-img-file-input"
            type="file"
            className="profile-img-file-input"
            name="image"
            onChange={(e) => {
              handleUploadStartImage(e.target.files?.[0] || null);
            }}
          />
          <img
            src={
              routineInfo?.start_training_image
                ? backendURL + '/' + routineInfo.start_training_image
                : ''
            }
            className="  img-thumbnail "
            alt="start-image"
          />
        </div>
      </div>
      <div className="col-6">
        End Image
        <div className="">
          <input
            id="profile-img-file-input"
            type="file"
            className="profile-img-file-input"
            name="image"
            onChange={(e) => {
              handleUploadEndImage(e.target.files?.[0] || null);
            }}
          />
          <img
            src={backendURL + '/' + routineInfo?.end_training_image}
            className="  img-thumbnail "
            alt="end-image"
          />
        </div>
      </div>
    </div>
  );
};

export default EndandStartImage;
